import React from 'react';
import '../styles/mapHeader.css';

interface Props {
  onSelectLocation: () => void;
  showWalks: boolean;
  setShowWalks: React.Dispatch<React.SetStateAction<boolean>>;
  showCampsites: boolean;
  setShowCampsites: React.Dispatch<React.SetStateAction<boolean>>;
}


const MapHeader: React.FC<Props> = ({ onSelectLocation, showWalks, setShowWalks, showCampsites, setShowCampsites }) => {
  return (
    <div className="map-header">
      <button className="header-btn" onClick={onSelectLocation}>
        🔍 Search
      </button>

      <select
        className="header-btn"
        value={showCampsites ? "show" : "hide"}
        onChange={(e) => setShowCampsites(e.target.value === "show")}
      >
        <option value="show">🏕️ Campsites</option>
        <option value="hide">🙈 Hide</option>
      </select>

      <select
        className="header-btn"
        value={showWalks ? "show" : "hide"}
        onChange={(e) => setShowWalks(e.target.value === "show")}
      >
        <option value="show">🐾 Walks</option>
        <option value="hide">🙈 Hide</option>
      </select>
    </div>

  );
};


export default MapHeader;
